/**
 * Runtime mirror of `@vulog/auth`'s `AuthMode` union.
 *
 * The package declares `type AuthMode = 'ropc' | 'oauth2' | 'microsoft'`, but a
 * type-only export vanishes at runtime for a JS consumer, so the values were
 * being repeated as bare literals across the helpers, the sagas and the test
 * mock. A typo in any of those reads as "this tenant has no SSO" rather than as
 * an error, so the set is named once here.
 */
export const AUTH_MODES = {
    ROPC: 'ropc',
    OAUTH2: 'oauth2',
    MICROSOFT: 'microsoft',
};

export default AUTH_MODES;
